import { createRouter, createWebHistory } from "vue-router"
import DashboardView from "../views/DashboardView.vue"
import AddView from "../views/AddView.vue"
import AuthView from "../views/AuthView.vue"
import SearchView from "../views/SearchView.vue"
import MonthView from "../views/MonthView.vue"
import MealPlanView from "../views/MealPlanView.vue"
import { useTokenStore } from "@/stores/token"
import SignupView from "../views/SignupView.vue"
// import HomePageView from "../views/HomePageView.vue"
// import HomePageView from "@/views/NewHomePage.vue"
import HomePageView from "@/views/HomepageView.vue"
import PrivacyPolicyView from "../views/PrivacyPolicyView.vue"
import TermsOfUseView from "../views/TermsOfUseView.vue"
import ProfileView from "../views/ProfileView.vue"
import ReportView from "../views/ReportView.vue"
import FoodCheckerView from "../views/FoodCheckerView.vue"
import ManageInvitesView from "../views/admin/ManageInvitesView.vue"
import ManageAmazonAffiliatesView from "../views/admin/ManageAmazonAffiliates.vue"
import ForgotPasswordView from "../views/ForgotPasswordView.vue"
import ResetPasswordView from "../views/ResetPasswordView.vue"
import UnsubscribeView from "../views/UnsubscribeView.vue"
import AchievementView from "../views/AchievementView.vue"
import SubscriptionView from "@/views/SubscriptionView.vue"
import UserManagementView from "@/views/admin/UserManagementView.vue"
import PricingView from "../views/PricingView.vue"

const router = createRouter({
	history: createWebHistory(import.meta.env.BASE_URL),
	routes: [
		{
			path: "/",
			name: "home",
			component: HomePageView,
		},
		{
			path: "/privacy-policy",
			name: "privacy-policy",
			component: PrivacyPolicyView,
		},
		{
			path: "/terms",
			name: "terms",
			component: TermsOfUseView,
		},
		{
			path: "/profile",
			name: "profile",
			component: ProfileView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/report",
			name: "report",
			component: ReportView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/dashboard",
			name: "dashboard",
			component: DashboardView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/month-view",
			name: "month-view",
			component: MonthView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/food-checker",
			name: "food-checker",
			component: FoodCheckerView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/search",
			name: "search",
			component: SearchView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/add",
			name: "add",
			component: AddView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/meal-plan",
			name: "meal-plan",
			component: MealPlanView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/signin",
			name: "signin",
			component: AuthView,
			meta: {
				authenticated: false,
			},
		},
		{
			path: "/signup",
			name: "signup",
			component: SignupView,
			meta: {
				authenticated: false,
			},
		},
		{
			path: "/admin/manage-invites",
			name: "manage-invites",
			component: ManageInvitesView,
			meta: {
				authenticated: true,
				role: "admin",
			},
		},
		{
			path: "/admin/manage-ach",
			name: "manage-ach",
			component: AchievementView,
			meta: {
				authenticated: true,
				role: "admin",
			},
		},
		{
			path: "/admin/amazon",
			name: "amazon",
			component: ManageAmazonAffiliatesView,
			meta: {
				authenticated: true,
				role: "admin",
			},
		},
		{
			path: "/forgot-password",
			name: "forgot-password",
			component: ForgotPasswordView,
			meta: {
				authenticated: false,
			},
		},
		{
			path: "/reset-password/:token",
			name: "reset-password",
			component: ResetPasswordView,
			meta: {
				authenticated: false,
			},
		},
		{
			path: "/unsubscribe",
			name: "unsubscribe",
			component: UnsubscribeView,
		},
		{
			path: "/subscription",
			name: "subscription",
			component: SubscriptionView,
			meta: {
				authenticated: true,
			},
		},
		{
			path: "/admin/users",
			name: "admin-users",
			component: UserManagementView,
			meta: {
				authenticated: true,
				role: "admin",
			},
		},
		{
			path: "/pricing",
			name: "pricing",
			component: PricingView,
		},
	],
})

router.beforeEach(async (to, from) => {
	//load the token when routing to a page
	const ts = useTokenStore()
	await ts.loadTokens()

	// Always allow access to privacy policy and terms pages
	if (to.name === "privacy-policy" || to.name === "terms") {
		return true
	}

	if (to.meta.authenticated && !ts.hasToken()) {
		return { name: "signin" }
	} else if (to.meta.authenticated === false && ts.hasToken()) {
		return { name: "dashboard" }
	} else if (
		to.meta.authenticated === true &&
		ts.hasToken() &&
		to.meta.role &&
		to.meta.role !== ts.getRole()
	) {
		return { name: "dashboard" }
	} else if (to.name === "home" && ts.hasToken()) {
		return { name: "dashboard" }
	}
})

export default router
